export const STATUS_TYPES = {
  quote: 'QUOTE',
  order: 'ORDER',
  all: 'ALL'
};

export const DISPATCHED_STATUS = 'DISPATCHED';
export const CANCELED_STATUS = 'CANCELED';
